// Single source of truth for the subscription-module abbreviation
// badges — used by SubscriptionsTab, SiteSubscriptionPanel and
// LeadSubscriptionsTab. Mirrors the server's MODULE_BADGES in
// statementGenerator.js so the web UI and the rendered statement PDF
// stay visually coherent (same abbreviation + tone per module).
//
// `tone` maps to an existing .badge-<tone> class in global.css. Where
// the spec calls for two modules to share a tone (e.g. PLR pink +
// nothing else; INV/DLR both yellow), readers tell them apart by the
// abbreviation — explicit user direction from the badge-spec round.
//
// Adding a new module: register it here, drop the matching entry into
// statementGenerator.js MODULE_BADGES (keep abbr + hex tone in sync),
// and the three subscription grids pick it up automatically.

const MODULE_BADGES = {
  live_transactions: { abbr: 'RTI', tone: 'orange' }, // Real Time Inventory
  price_book:        { abbr: 'PB',  tone: 'blue' },
  fuel_manager:      { abbr: 'FM',  tone: 'green' },
  charge:            { abbr: 'CHG', tone: 'purple' },
  tx_exempt:         { abbr: 'TX',  tone: 'red' },
  car_wash:          { abbr: 'CW',  tone: 'teal' },
  adv_report:        { abbr: 'ADV', tone: 'purple' },
  fuel_price:        { abbr: 'FPC', tone: 'teal' },
  case_break:        { abbr: 'CB',  tone: 'amber' }, // kept (not in user's spec; existing mustard-ish)
  dealer_comm:       { abbr: 'DLR', tone: 'yellow' },
  time_rest:         { abbr: 'TR',  tone: 'grey' },
  sft_file:          { abbr: 'SFT', tone: 'blue' },
  private_label:     { abbr: 'PLR', tone: 'pink' },
  imperial_import:   { abbr: 'IMP', tone: 'grey' },
  fuel_grade_report: { abbr: 'FGR', tone: 'green' },
  inventory_control: { abbr: 'INV', tone: 'yellow' }
};

export function moduleBadge(key) {
  return MODULE_BADGES[key] || null;
}

export default MODULE_BADGES;
